export enum Environments {
  DEV = "dev",
  STAGING = "staging"
}

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as Environments

export const getEndpoint = (environment: Environments) => {
  if (environment === Environments.DEV) {
    return {
      signIn: "https://e2h4duugj7.execute-api.us-east-1.amazonaws.com/dev/signin",
      signUp: "https://e2h4duugj7.execute-api.us-east-1.amazonaws.com/dev/signup",
      logs: "https://53n591b56j.execute-api.us-east-1.amazonaws.com/dev/synced-orders-logs",
      settings: "https://qce4uvys01.execute-api.us-east-1.amazonaws.com/dev/settings",
      checkAccessTokens: "https://eupabdc319.execute-api.us-east-1.amazonaws.com/dev/check-access-tokens",
      ordersUrl: "https://5z54x9pp8e.execute-api.us-east-1.amazonaws.com/dev/orders",
      tiktokLogout: "https://2hae23pdzi.execute-api.us-east-1.amazonaws.com/dev/tk-logout",
      veeqoLogout: "https://7ymk831ge9.execute-api.us-east-1.amazonaws.com/dev/veeqo-logout",
      tiktokToVeeqoOrdersSyncInitialize:
        "https://m7nratclwg.execute-api.us-east-1.amazonaws.com/dev/tiktok-to-veeqo-orders-sync-initialize",
      resetPassword: "https://e2h4duugj7.execute-api.us-east-1.amazonaws.com/dev/reset-password",
      subscriptionDetails: "https://61imw51qs3.execute-api.us-east-1.amazonaws.com/dev/subscription-details",
      subscriptionActivate:
        "https://61imw51qs3.execute-api.us-east-1.amazonaws.com/dev/create-checkout-session",
      subscriptionUpdate: "https://61imw51qs3.execute-api.us-east-1.amazonaws.com/dev/update-subscription",
      countSyncedOrders: "https://6hggfbeh5a.execute-api.us-east-1.amazonaws.com/dev/count-synced-orders",
      countCurrentSubscriptionSyncedOrders:
        "https://6hggfbeh5a.execute-api.us-east-1.amazonaws.com/dev/count-current-subscription-synced-orders",
      releaseSubscriptionSchedule:
        "https://61imw51qs3.execute-api.us-east-1.amazonaws.com/dev/release-subscription-schedule"
    }
  }

  if (environment === Environments.STAGING) {
    return {
      auth: "https://8ai0omt908.execute-api.us-east-1.amazonaws.com/staging/auth",
      veeqoLogin: "https://ludns5tpul.execute-api.us-east-1.amazonaws.com/staging/veeqo-login",
      veeqoLoginCallback:
        "https://ludns5tpul.execute-api.us-east-1.amazonaws.com/staging/veeqo-login-callback",
      tiktokLogout: "https://8ai0omt908.execute-api.us-east-1.amazonaws.com/staging/tk-logout",
      veeqoLogout: "https://ludns5tpul.execute-api.us-east-1.amazonaws.com/staging/veeqo-logout",
      signUp: " https://e2by2htsmc.execute-api.us-east-1.amazonaws.com/staging/signup",
      signIn: "https://e2by2htsmc.execute-api.us-east-1.amazonaws.com/staging/signin",
      checkAccessTokens: "https://ff1roz5r2b.execute-api.us-east-1.amazonaws.com/staging/check-access-tokens",
      logs: "https://lgxuq3pet5.execute-api.us-east-1.amazonaws.com/staging/logs",
      getAllProducts: "https://golw747f0i.execute-api.us-east-1.amazonaws.com/staging/get-all-products",
      product: "https://golw747f0i.execute-api.us-east-1.amazonaws.com/staging/product",
      order: "https://golw747f0i.execute-api.us-east-1.amazonaws.com/staging/order",
      settings: "https://bi7ef0mzub.execute-api.us-east-1.amazonaws.com/staging/settings",
      initiateSubscription:
        "https://x43vhc9owj.execute-api.us-east-1.amazonaws.com/staging/initiate-subscription",
      createPaymentDetails:
        "https://x43vhc9owj.execute-api.us-east-1.amazonaws.com/staging/create-payment-details",
      tiktokToVeeqoOrdersSyncInitialize:
        "https://msl95qijc4.execute-api.us-east-1.amazonaws.com/staging/tiktok-to-veeqo-orders-sync-initialize",
      resetPassword: "",
      subscriptionDetails:
        "https://x43vhc9owj.execute-api.us-east-1.amazonaws.com/staging/subscription-details",
      subscriptionActivate:
        "https://x43vhc9owj.execute-api.us-east-1.amazonaws.com/staging/create-checkout-session",
      subscriptionUpdate:
        "https://x43vhc9owj.execute-api.us-east-1.amazonaws.com/staging/update-subscription",
      countSyncedOrders: "",
      countCurrentSubscriptionSyncedOrders:
        "https://1kusq9setk.execute-api.us-east-1.amazonaws.com/staging/count-current-subscription-synced-orders",
      releaseSubscriptionSchedule: ""
    }
  }
}
